import axiosClient from "../api/axiosClient";

/**
 * Event History & Media Engagement service.
 * Ported 1:1 from the React Native app's event-history, media-history-event
 * (liked-media / downloaded-media), and downloaded-participants screens
 * (src/Screens/*) and the API functions they call in
 * src/services/api/index.js + src/services/constants/index.js. No new
 * backend endpoints — all of the below are already live.
 *
 * Two response-shape quirks are normalized here so callers always get a
 * consistent {items, totalCount}:
 *  - Likes endpoints return a flat {Result, TotalCount}; downloads endpoints
 *    return a nested {Result: {Data, TotalCount}}.
 *  - The downloads-history endpoint takes `page`, not `pageNumber`, unlike
 *    every other paginated endpoint in this codebase.
 */

// --- Event history ---
/** @param {{pageNumber, pageSize}} params */
export const getEventHistory = (params) =>
  axiosClient.get("/Events/MyEventHistory", { params: { ...params, myEvent: true } });

// --- Per-event media engagement ---
/** @param {string|number} eventId @param {{pageNumber, pageSize}} params */
export const getEventLikedMedia = async (eventId, { pageNumber = 1, pageSize = 20 } = {}) => {
  const res = await axiosClient.get("/Image/Gallery/PromoterReactions", {
    params: { chatRoomId: eventId, pageNumber, pageSize },
  });
  return { items: res.data?.Result || [], totalCount: res.data?.TotalCount || 0 };
};

/** @param {string|number} eventId @param {{pageNumber, pageSize}} params */
export const getEventDownloadedMedia = async (eventId, { pageNumber = 1, pageSize = 20 } = {}) => {
  const res = await axiosClient.get("/Chat/Gallery/EventDownloadHistory", {
    params: { eventId, page: pageNumber, pageSize },
  });
  return { items: res.data?.Result?.Data || [], totalCount: res.data?.Result?.TotalCount || 0 };
};

// --- Who liked / downloaded a specific media item ---
/** @param {string|number} imageId */
export const getMediaLikedUsers = async (imageId) => {
  const res = await axiosClient.get("/Image/Gallery/ReactionUsers", { params: { imageId } });
  return { items: res.data?.Result || [], totalCount: res.data?.Result?.length || 0 };
};

/** @param {string|number} mediaId */
export const getMediaDownloadedUsers = async (mediaId) => {
  const res = await axiosClient.get(`/Chat/Gallery/EventDownloadHistoryUsers?mediaId=${mediaId}`);
  return { items: res.data?.Result?.Data || [], totalCount: res.data?.Result?.TotalCount || 0 };
};
